import React from "react";
import PropTypes from "prop-types";
import { Dimmer, Loader } from "semantic-ui-react";

/**
 * Loading component that shows full size in it's parent container.
 * This content loader is meant to be used only at the index.jsx files
 * We cannot have translation at the Suspense.
 * The translation might have not been loaded yet.
 */
const ContentLoaderSimple = ({ isLoading }) => {
  if (!isLoading) {
    return <div />;
  }

  return (
    <Dimmer active inverted>
      <Loader inverted />
    </Dimmer>
  );
};

ContentLoaderSimple.propTypes = {
  isLoading: PropTypes.bool,
};

ContentLoaderSimple.defaultProps = {
  isLoading: true,
};

export default ContentLoaderSimple;
